import React, { ComponentPropsWithoutRef } from 'react';
import classnames from 'classnames';

interface Props extends Omit<ComponentPropsWithoutRef<'input'>, 'onChange'> {
  inputRef?: React.RefObject<any>;
  type?: 'text' | 'number' | 'uppercase';
  leftIcon?: JSX.Element;
  rightIcon?: JSX.Element;
  containerStyle?: object;
  inputContainerStyle?: string;
  onChange?: (text: string) => void;
}

export default function TextInput(props: Props) {
  const { inputRef, type, leftIcon, rightIcon, containerStyle, inputContainerStyle, className, onChange, ...rest } =
    props;

  function changeValue(e: any) {
    switch (type) {
      case 'number':
        return /^\d+$/.test(e.target.value) || e.target.value === '' ? onChange && onChange(e.target.value) : undefined;
      case 'uppercase':
        return onChange && onChange(e.target.value.toUpperCase());
      default:
        return onChange && onChange(e.target.value);
    }
  }

  return (
    <div
      className={classnames(
        'placeholder:text-brand-text-secondary text-brand-text-primary border rounded-lg flex flex-row px-md py-sm items-center justify-between',
        inputContainerStyle ?? '',
      )}
      style={containerStyle}
    >
      {leftIcon && leftIcon}
      <div className="w-full">
        <input
          {...rest}
          type="text"
          value={rest.value ?? ''}
          ref={inputRef}
          onChange={changeValue}
          className={classnames('w-full placeholder:text-brand-text-secondary disabled:pointer-events-none', className)}
        />
      </div>
      {rightIcon && rightIcon}
    </div>
  );
}
